import React from 'react';
import { Button } from '@/components/ui/button';
import { Check, ArrowRight } from 'lucide-react';

const ShopwareCTA = () => {
  return (
    <section id="contact" className="py-16 md:py-24 bg-gradient-to-br from-blue-600 to-indigo-700 text-white">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <div className="inline-block bg-white/20 text-white text-sm font-semibold px-3 py-1 rounded-full mb-4">
              Kostenlose Beratung
            </div>
            
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
              Lass deinen Shopware Shop von Experten programmieren
            </h2>
            
            <p className="text-lg opacity-90 mb-8">
              Sichere dir jetzt dein unverbindliches Erstgespräch und erfahre, wie wir deinen 
              perfekten Shopware-Shop entwickeln können – maßgeschneidert für deinen Erfolg im E-Commerce.
            </p>
            
            <div className="space-y-4 mb-8">
              <div className="flex items-center gap-3">
                <Check className="h-5 w-5 text-green-400" />
                <p>Kostenlose und unverbindliche Beratung</p>
              </div>
              <div className="flex items-center gap-3">
                <Check className="h-5 w-5 text-green-400" />
                <p>Individuelle Analyse deiner Anforderungen</p>
              </div>
              <div className="flex items-center gap-3">
                <Check className="h-5 w-5 text-green-400" />
                <p>Transparente Kostenübersicht</p>
              </div>
              <div className="flex items-center gap-3">
                <Check className="h-5 w-5 text-green-400" />
                <p>Zeitplan und konkrete nächste Schritte</p>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="bg-white hover:bg-gray-100 text-blue-700 px-8">
                <a href="tel:+4969123456789">+49 69 123 456 789</a>
              </Button>
              <Button asChild size="lg" variant="outline" className="border-white text-white hover:bg-white/10">
                <a href="mailto:info@splusd-solutions.com" className="flex items-center gap-2">
                  info@splusd-solutions.com
                  <ArrowRight size={16} />
                </a>
              </Button>
            </div>
          </div>
          
          <div className="bg-white rounded-xl shadow-xl p-8">
            <h3 className="text-2xl font-bold text-gray-800 mb-6">Termin vereinbaren</h3>
            
            <form className="space-y-5">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Name*</label>
                <input
                  type="text"
                  id="name"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900"
                  placeholder="Dein Name"
                  required
                />
              </div>
              
              <div>
                <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-1">Unternehmen*</label>
                <input
                  type="text"
                  id="company"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900"
                  placeholder="Dein Unternehmen"
                  required
                />
              </div>
              
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">E-Mail*</label>
                <input
                  type="email"
                  id="email"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900"
                  placeholder="deine@email.de"
                  required
                />
              </div>
              
              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">Telefon</label>
                <input
                  type="tel"
                  id="phone"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900"
                  placeholder="+49 123 456789"
                />
              </div>
              
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">Deine Anfrage</label>
                <textarea
                  id="message"
                  rows={3}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900"
                  placeholder="Beschreibe kurz dein Projekt oder deine Fragen"
                ></textarea>
              </div>
              
              <div className="pt-2">
                <Button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg text-lg font-medium">
                  Kostenloses Beratungsgespräch vereinbaren
                </Button>
              </div>
              
              <p className="text-xs text-gray-500 mt-4">
                Mit dem Absenden des Formulars akzeptierst du unsere 
                <a href="/datenschutz" className="underline ml-1">Datenschutzbestimmungen</a>.
                Wir melden uns innerhalb von 24 Stunden bei dir.
              </p>
            </form>
          </div>
        </div>
        
        <div className="mt-20 text-center">
          <p className="text-xl md:text-2xl font-bold mb-3">
            Lasse jetzt deinen maßgeschneiderten Shopware Shop programmieren!
          </p>
          <p className="opacity-90 md:text-lg">
            Kontaktiere uns für eine unverbindliche Beratung zu deinem individuellen E-Commerce-Projekt.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ShopwareCTA; 